import { createFileRoute } from "@tanstack/react-router";
import RequireAuth from "@/components/auth/RequireAuth";
import PageGate from "@/components/auth/PageGate";
import Bookmarks from "@/pages/Bookmarks";

export const Route = createFileRoute("/_app/bookmarks")({
  component: () => (
    <PageGate pageKey="bookmarks"><RequireAuth title="Bookmarks"><Bookmarks /></RequireAuth></PageGate>
  ),
});
